var _rect, _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAluminum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Aluminum catering pans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#f2f4f6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 430,
    rx: 285,
    ry: 34,
    fill: "#162d45",
    opacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 170h570l-75 240H190z",
    fill: "#d9e0e5",
    stroke: "#162d45",
    strokeWidth: 14,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 155h630v48H85z",
    fill: "#fff",
    stroke: "#162d45",
    strokeWidth: 14,
    rx: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225 235l-35 125M315 225l-18 155M400 220v165M485 225l18 155M575 235l35 125",
    stroke: "#aab6bf",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155 115h490",
    stroke: "#c49356",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAluminum);
export default __webpack_public_path__ + "static/media/aluminum.acc0273efac98f80e8434f7b9330f592.svg";
export { ForwardRef as ReactComponent };